import { createContext, useContext } from 'react';
import type { CreatureAdjustment } from '../utils/creatureAdjustments';

export interface OrcKnowledgeLinkTarget {
  type: string;
  id: string;
  label?: string;
  creatureAdjustment?: CreatureAdjustment;
}

export interface OrcKnowledgeModalContextValue {
  openOrcKnowledgeTarget: (target: OrcKnowledgeLinkTarget) => void;
}

const OrcKnowledgeModalContext = createContext<OrcKnowledgeModalContextValue>({
  openOrcKnowledgeTarget: () => {},
});

export const OrcKnowledgeModalContextProvider = OrcKnowledgeModalContext.Provider;

export function useOrcKnowledgeModal(): OrcKnowledgeModalContextValue {
  return useContext(OrcKnowledgeModalContext);
}
